export function formatBytes(bytes) {
    if (!bytes || bytes < 1) return '–';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / 1024 ** exponent;
    return `${value.toFixed(value >= 10 || exponent === 0 ? 0 : 1)} ${units[exponent]}`;
}

export function formatNumber(value) {
    if (value === undefined || value === null || Number.isNaN(value)) return '–';
    return new Intl.NumberFormat('de-DE').format(Math.round(value));
}

export function formatDuration(ms) {
    if (!ms || ms < 0) return '–';
    if (ms < 1000) return `${Math.round(ms)} ms`;
    const seconds = ms / 1000;
    if (seconds < 60) return `${seconds.toFixed(1)} s`;
    const minutes = Math.floor(seconds / 60);
    return `${minutes}:${String(Math.floor(seconds % 60)).padStart(2, '0')} min`;
}

/** mm:ss Countdown bis zu einem Zeitstempel. */
export function formatCountdown(targetMs) {
    const remaining = targetMs - Date.now();
    if (!targetMs || remaining <= 0) return null;
    const seconds = Math.ceil(remaining / 1000);
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}

export function formatTokensPerSecond(tokens, durationMs) {
    if (!tokens || !durationMs) return '–';
    return `${(tokens / (durationMs / 1000)).toFixed(1)} T/s`;
}

/**
 * Anteilswert als Prozent. Die API liefert je nach Feld einen Bruch (0..1)
 * oder bereits Prozent - Werte <= 1 werden deshalb als Bruch interpretiert.
 */
export function formatPercent(value) {
    if (value === null || value === undefined || Number.isNaN(value)) return '–';
    const percent = value <= 1 ? value * 100 : value;
    return `${percent.toFixed(percent >= 10 ? 0 : 1)} %`;
}

/** Stundenwert kompakt: unter einer Stunde in Minuten. */
export function formatHours(value) {
    if (value === null || value === undefined || Number.isNaN(value)) return '–';
    if (value === 0) return '0 h';
    if (value < 1) return `${Math.round(value * 60)} min`;
    return `${value.toFixed(value >= 10 ? 0 : 1)} h`;
}

export function formatTime(date) {
    return new Date(date).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
}
